import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import BrandButton from "../BrandButton";
import SearchForm from "../forms/SearchForm";
import { Navbar, NavbarBrand } from "reactstrap";
import { Translate } from "react-localize-redux";
import "./styles.scss";

class NavigationBar extends React.Component {
  static propTypes = {
    username: PropTypes.string,
    slug: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  handleOnLogout = () => {
    this.props.logout();
  };

  render() {
    return (
      <div>
        <Navbar expand="md" id="navbar-container">
          <NavbarBrand>
            <BrandButton />
          </NavbarBrand>

          <div className="d-none d-lg-block lg-search-container">
            <SearchForm />
          </div>

          {!this.props.loggedIn && (
            <React.Fragment>
              <div className="join-btn-container d-none d-lg-block">
                <NavLink to="/register" className="btn btn-primary join-btn">
                  <Translate id="JoinText" />
                </NavLink>
              </div>

              <div className="d-md-block d-lg-none">
                <NavLink to="/register" className="btn btn-primary join-btn">
                  <Translate id="JoinText" />
                </NavLink>
              </div>
            </React.Fragment>
          )}
          {/*<div className="d-md-flex d-lg-none md-search-container">*/}
          {/*  <SearchForm />*/}
          {/*</div>*/}
        </Navbar>

        <div className="d-md-flex d-lg-none md-search-container">
          <SearchForm />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, profile }) => ({ loggedIn: auth.loggedIn, slug: profile.profile.slug });

export default connect(mapStateToProps)(NavigationBar);



// WEBPACK FOOTER //
// ./src/components/NavigationBar/NavigationBar.jsx